import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../src/UnderlineNav2/UnderlineNav2.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {UnderlineNav} from '@primer/react/drafts'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Simple`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item aria-current="page">Code</UnderlineNav.Item>
  <UnderlineNav.Item>Issues</UnderlineNav.Item>
  <UnderlineNav.Item>Pull Requests</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`With Icons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository">
  <UnderlineNav.Item aria-current="page" icon={CodeIcon}>
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={IssueOpenedIcon} counter={30}>
    Issues
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={GitPullRequestIcon} counter={3}>
    Pull Requests
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={CommentDiscussionIcon}>Discussions</UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={9}>
    Actions
  </UnderlineNav.Item>
  <UnderlineNav.Item icon={EyeIcon} counter={7}>
    Projects
  </UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`Overflow Behaviour`}</h3>
    <p>{`Component first hides icons if they present to optimize for space and show as many items as possible. If there is still an overflow, it will display the items that don't fit in the `}<inlineCode parentName="p">{`More`}</inlineCode>{` menu.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "noinline live drafts",
        "noinline": true,
        "live": true,
        "drafts": true
      }}>{`const Navigation = () => {
  const items = [
    {navigation: 'Code', icon: CodeIcon},
    {navigation: 'Issues', icon: IssueOpenedIcon, counter: 120},
    {navigation: 'Pull Requests', icon: GitPullRequestIcon, counter: 13},
    {navigation: 'Discussions', icon: CommentDiscussionIcon, counter: 5},
    {navigation: 'Actions', icon: PlayIcon, counter: 4},
    {navigation: 'Projects', icon: ProjectIcon, counter: 9},
    {navigation: 'Insights', icon: GraphIcon},
    {navigation: 'Settings', icon: GearIcon, counter: 10},
    {navigation: 'Security', icon: ShieldLockIcon},
  ]
  const [selectedIndex, setSelectedIndex] = React.useState(0)
  return (
    <Box sx={{width: 750, border: '1px solid', borderBottom: 0, borderColor: 'border.default'}}>
      <UnderlineNav aria-label="Repository">
        {items.map((item, index) => (
          <UnderlineNav.Item
            key={item.navigation}
            icon={item.icon}
            aria-current={index === selectedIndex ? 'page' : undefined}
            onSelect={e => {
              setSelectedIndex(index)
              e.preventDefault()
            }}
            counter={item.counter}
          >
            {item.navigation}
          </UnderlineNav.Item>
        ))}
      </UnderlineNav>
    </Box>
  )
}
render(<Navigation />)
`}</code></pre>
    <h3>{`Loading State For Counters`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<UnderlineNav aria-label="Repository" loadingCounters={true}>
  <UnderlineNav.Item counter={4} aria-current="page">
    Code
  </UnderlineNav.Item>
  <UnderlineNav.Item counter={44}>Issues</UnderlineNav.Item>
  <UnderlineNav.Item>Pull Requests</UnderlineNav.Item>
</UnderlineNav>
`}</code></pre>
    <h3>{`With React Router`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {Link, useMatch, useResolvedPath} from 'react-router-dom'
import {UnderlineNav} from '@primer/react/drafts'

function UnderlineNavItem({to, children, ...rest}) {
  const resolved = useResolvedPath(to)
  const isCurrent = useMatch({path: resolved.pathname, end: true})
  return (
    <UnderlineNav.Item as={Link} to={to} aria-current={isCurrent ? 'page' : undefined} {...rest}>
      {children}
    </UnderlineNav.Item>
  )
}

const Navigation = () => {
  return (
    <UnderlineNav aria-label="Repository">
      <UnderlineNavItem to="/code" counter={4}>
        Code
      </UnderlineNavItem>
      <UnderlineNavItem to="/issues" counter={44}>
        Issues
      </UnderlineNavItem>
      <UnderlineNavItem to="/pulls">Pull Requests</UnderlineNavItem>
    </UnderlineNav>
  )
}
`}</code></pre>
    <h3>{`With Next.js`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useRouter} from 'next/router'
import Link from 'next/link'
import {UnderlineNav} from '@primer/react/drafts'

function UnderlineNavItem({href, children, ...rest}) {
  const router = useRouter()
  const isCurrent = typeof href === 'string' ? router.asPath === href : router.pathname === href.pathname
  return (
    <UnderlineNav.Item s={Link} href={href} aria-current={isCurrent ? 'page' : undefined} {...rest}>
      {children}
    </UnderlineNav.Item>
  )
}

const Navigation = () => {
  return (
    <UnderlineNav aria-label="Repository">
      <UnderlineNavItem href="/code" counter={4}>
        Code
      </UnderlineNavItem>
      <UnderlineNavItem href="/issues" counter={44}>
        Issues
      </UnderlineNavItem>
      <UnderlineNavItem href="/pulls">Pull Requests</UnderlineNavItem>
    </UnderlineNav>
  )
}
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      visualRegressionCoverage: true,
      noAxeViolations: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: true,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      